import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axiosInstance';

const initialState = {
  subscriptions: {}, 
  loading: false,
  error: null,
  pagination: {},
  selectedSubscription: null,
  subscriptionHistory:{
    histories:{},
    pagination:{},
    loading: false
  }
};

/* ================== THUNKS ================== */

export const fetchSubscriptions = createAsyncThunk(
  'subscriptions/fetch',
  async ({ fetchType = "table", page = 1, limit = 10, search = '' }, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.get('/api/admin/subscriptions', {
          params: { fetchType, page, limit, search }
        });
        return {
            data: response.data?.data?.records || [],
            pagination: response.data?.data?.pagination || {},
        };
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

export const createSubscription = createAsyncThunk(
  'subscriptions/create',
  async (payload, { rejectWithValue }) => {
    try {
      console.log(payload,'payload');
      const response = await axiosInstance.post(
        '/api/admin/subscriptions', 
        payload
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

export const fetchSubscriptionById = createAsyncThunk(
  'subscriptions/fetchById',
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/api/admin/subscriptions/${id}`);
      return response.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

export const updateSubscription = createAsyncThunk(
  'subscriptions/update',
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(`/api/admin/subscriptions/${id}`, data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

export const deleteSubscription = createAsyncThunk(
  'subscriptions/delete',
  async ({ id }, { rejectWithValue }) => {
    try {
      await axiosInstance.delete(`/api/admin/subscriptions/${id}`);
      return { id };
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

export const toggleSubscriptionStatus = createAsyncThunk(
  'subscriptions/toggle-status',
  async ({id}, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.patch(`/api/admin/subscriptions/${id}/status`);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

export const assignSubscription = createAsyncThunk(
  'subscriptions/assign',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(`/api/admin/subscriptions/assign`,payload);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

export const revokeSubscription = createAsyncThunk(
  'subscriptions/revoke',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.patch(`/api/admin/subscriptions/revoke`,payload);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

export const getUserSubscription = createAsyncThunk(
  'subscriptions/get-user-subscription',
  async ({userId}, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(`/api/admin/subscriptions/user/${userId}`);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);


export const getSubscriptionsHistory = createAsyncThunk(
  'subscriptions/get-user-subscription-history',
  async ({page = 1, limit = 10, search = '', status="" }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/api/admin/subscriptions/history`, {
          params: { status, page, limit, search }
        });
      return {
          data: response.data?.data?.records || [],
          pagination: response.data?.data?.pagination || {},
      };
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);


/* ================== SLICE ================== */

const subscriptionSlice = createSlice({
  name: 'subscriptions',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
        /* FETCH */
        .addCase(fetchSubscriptions.pending, (state) => {
            state.loading = true;
        })
        .addCase(fetchSubscriptions.fulfilled, (state, action) => {
            const { data, pagination } = action.payload;
            state.loading = false;
            state.pagination = pagination;
            state.subscriptions = data;
        })
        .addCase(fetchSubscriptions.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })

        /* CREATE */
        // .addCase(createSubscription.fulfilled, (state, action) => {
            
        // })

        .addCase(fetchSubscriptionById.fulfilled, (state, action) => {
            state.loading = false;
            state.selectedSubscription = action.payload;
        })
        .addCase(fetchSubscriptionById.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })

        /* UPDATE */
        .addCase(updateSubscription.fulfilled, (state, action) => {        
            console.log(state,'state');
        })
        .addCase(updateSubscription.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        .addCase(toggleSubscriptionStatus.fulfilled, (state, action) => {
            state.loading = false;
            const updated = action.payload?.data;

            if (updated) {
                state.subscriptions = state.subscriptions.map((c) =>
                    c.id === updated.id ? updated : c
                );

                state.selectedSubscription = updated;
            }
        })
        .addCase(getSubscriptionsHistory.pending, (state) => {
          state.subscriptionHistory.loading = true;
        })
        .addCase(getSubscriptionsHistory.fulfilled, (state, action) => {
          const { data, pagination } = action.payload;
          state.subscriptionHistory.loading = false;
          state.subscriptionHistory.pagination = pagination;
          state.subscriptionHistory.histories = data;
        })
        .addCase(getSubscriptionsHistory.rejected, (state, action) => {
          state.subscriptionHistory.loading = false;
          state.error = action.payload;
        })

      /* DELETE */
      .addCase(deleteSubscription.fulfilled, (state, action) => {
        state.subscriptions = state.subscriptions.filter((p) => p._id !== action.payload);
      });
  }
});

export default subscriptionSlice.reducer;